export default {
    details: undefined,
    selectedChildren: undefined,
    selectedChild: undefined,
    selectedMedia: null,
    quantity: 1,
    selectedCode: '',
    byId: {},
};
